import React from "react";
import { formatCurrency } from "../../utils/helpers";

const HeaderOptionsBar = ({
  mode = "inventory",
  /** Rendered to the left of Grand Total MRC (e.g. MonthYearSelector) */
  periodSelector,
  /** { monthLabel: string, year: number } shown beside grand total */
  displayPeriod,
  grandTotalMRC,
  loading,
  exporting,
  deleting,
  onExport,
  onDelete,
  // Client admin mode props
  activeTab = "upload",
  onTabChange,
  onNavigate,
}) => {
  if (mode === "inventory") {
    return (
      <div className="flex justify-between items-center gap-3 min-w-0 w-full flex-wrap">
        <div className="text-[18px] font-bold text-gray-900 flex-shrink-0">
          Inventory Dashboard
        </div>
        <div className="flex items-center gap-3 sm:gap-4 justify-end flex-1 min-w-0 flex-wrap">
          {periodSelector ? (
            <div className="min-w-0 flex-shrink">{periodSelector}</div>
          ) : null}
          {displayPeriod?.monthLabel != null && displayPeriod?.year != null ? (
            <div className="text-right flex-shrink-0 leading-tight hidden sm:block">
              <div className="text-[15px] font-semibold text-gray-900">
                {displayPeriod.monthLabel}
              </div>
              <div className="text-[15px] font-semibold text-gray-900">
                {displayPeriod.year}
              </div>
            </div>
          ) : null}
          <div className="text-right flex-shrink-0 leading-tight">
            <div className="text-[18px] font-bold text-gray-900">
              {loading ? "Loading..." : formatCurrency(grandTotalMRC || 0)}
            </div>
            <div className="text-[14px] text-gray-700">Grand Total MRC</div>
          </div>
          {typeof onExport === "function" && (
            <button
              onClick={onExport}
              disabled={exporting || loading}
              className="bg-green-600 hover:bg-green-700 text-white px-3 py-2 rounded-md text-[15px] font-medium disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors whitespace-nowrap"
            >
              {exporting ? "Exporting..." : "Export"}
            </button>
          )}
          {typeof onDelete === "function" && (
            <button
              onClick={onDelete}
              disabled={deleting || loading}
              className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-2 rounded-md text-[15px] font-medium disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors whitespace-nowrap"
            >
              {deleting ? "Deleting..." : "Delete"}
            </button>
          )}
        </div>
      </div>
    );
  }

  if (mode === "client-admin") {
    return (
      <div className="flex justify-between items-center min-w-0 w-full mb-3">
        <div className="text-[18px] font-bold text-gray-900 flex-shrink-0">
          Client Administration
        </div>
      </div>
    );
  }

  return null;
};

export default HeaderOptionsBar;
